const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const GOOGLE_AUTH_URL = process.env.REACT_APP_EMERGENT_AUTH_URL;

if (!API_BASE_URL) throw new Error('REACT_APP_BACKEND_URL is required');
if (!GOOGLE_AUTH_URL) throw new Error('REACT_APP_EMERGENT_AUTH_URL is required');

const request = async (path, options = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}${path}`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
      ...options,
    });
    const data = await response.json().catch(() => null);
    return response.ok ? { ok: true, data } : { ok: false, status: response.status, error: data?.detail || 'Request failed' };
  } catch {
    return { ok: false, status: 0, error: 'Unable to reach the server' };
  }
};

export const beginCustomerLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + '/diy';
  window.location.href = `${GOOGLE_AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const exchangeCustomerSession = (sessionId) => request('/api/customer-auth/session', { method: 'POST', body: JSON.stringify({ session_id: sessionId }) });
export const getCurrentCustomer = () => request('/api/customer-auth/me');
export const logoutCustomer = () => request('/api/customer-auth/logout', { method: 'POST' });